var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartsSolid = function SvgHeartsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.992 10.546c-.845-2.2-2.991-3.75-5.659-3.255-2.949.547-4.883 3.228-4.48 6.145.144 1.043.597 2.715 1.061 4.279.472 1.588.98 3.144 1.264 3.995l.006.02c.032.097.073.218.117.324.054.126.139.294.29.453.2.212.46.362.744.43.213.05.4.04.537.023.114-.014.239-.04.34-.06l.02-.004c.877-.18 2.48-.519 4.09-.904 1.588-.38 3.262-.823 4.238-1.22 2.713-1.105 4.129-4.115 3.076-6.965-.938-2.54-3.32-3.631-5.644-3.261Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.595 1.493c-2.46-1.133-4.914-.22-6.297 1.685-2.152-.958-4.766-.536-6.302 1.7C.297 7.35.826 10.613 3.172 12.391c.42.318 1.007.694 1.671 1.088-.419-3.897 2.214-7.429 6.125-8.155 2.805-.52 5.164.584 6.662 2.403a5.423 5.423 0 0 0-3.035-6.234Z",
    fill: "currentcolor"
  })));
};
export default SvgHeartsSolid;